import React, { useRef } from 'react';
import { Button as RBButton } from 'react-bootstrap';
import { FaCheckCircle, FaTimesCircle } from 'react-icons/fa';
import { Modal, ModalBody, ModalFooter, ModalHeader } from 'reactstrap';

import { EmployeeConfigMasterForm, EmployeeConfigMasterFormRefHandle } from './EmployeeConfigMasterForm';
import { EmployeeConfigMaster } from 'models/config/EmployeeConfigMaster';

export type EmployeeConfigMasterFormModalProps = {
    title: string;
    isOpen: boolean;
    onClose: () => void;
    disabledKeyField?: boolean;
    defaultValues?: EmployeeConfigMaster;
    onSubmit?: (employeeConfigMaster: EmployeeConfigMaster) => void;
};

export const EmployeeConfigMasterFormModal = (
    props: EmployeeConfigMasterFormModalProps
) => {
    const {
        disabledKeyField,
        title,
        isOpen,
        onClose,
        defaultValues,
        onSubmit
    } = props;

    const formRef = useRef<EmployeeConfigMasterFormRefHandle>(null);

    const handleSaveClick = () => {
        const employeeConfigMaster = formRef.current?.submit();
        if (!employeeConfigMaster) {
            return;
        }

        onSubmit?.(employeeConfigMaster);
    };

    return (
        <Modal
            isOpen={isOpen}
            toggle={onClose}
        >
            <ModalHeader toggle={onClose}>{title}</ModalHeader>
            <ModalBody>
                <EmployeeConfigMasterForm
                    ref={formRef}
                    disabledKeyField={disabledKeyField}
                    defaultValues={defaultValues}
                />
            </ModalBody>
            <ModalFooter className="tw-flex tw-justify-end">
                <RBButton variant="primary" onClick={handleSaveClick}>
                    <FaCheckCircle /> Save
                </RBButton>
                <RBButton variant="danger" onClick={onClose}>
                    <FaTimesCircle /> Close
                </RBButton>
            </ModalFooter>
        </Modal>
    );
};
